module.exports = __webpack_public_path__ + "img/header-weddingRingsPalladium.508cfbf.jpg";